import { createSelector } from 'reselect'

import API from '../api/api'

export const GET_CLIENTS = 'GET_CLIENTS'
export const SET_CLIENTS = 'SET_CLIENTS'
export const SELECT_CLIENT = 'SELECT_CLIENT'
export const GET_TRAINERS = 'GET_TRAINERS'
export const SET_LOADING = 'SET_LOADING'
const SET_APPROVE_REQUIRED = 'SET_APPROVE_REQUIRED'

export const initialState = {
  clients: [],
  clientData: {},
  loadedAllClients: false,
  trainers: [],
  loadingClients: false,
  isNewClientApproveRequired: false,
}

const removeDuplic = (arr) => {
  const tempArr = []
  return arr
    .map((obj) => {
      if (!tempArr.includes(obj.id)) {
        tempArr.push(obj.id)
        return obj
      } else {
        return undefined
      }
    })
    .filter((x) => x)
}

const clientsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CLIENTS:
      if (action.page === 1) {
        if (action.updateOnlyClientsList) {
          return {
            ...state,
            clients: removeDuplic(action.clients),
            loadedAllClients: action.loadedAllClients,
          }
        } else {
          return {
            ...state,
            clients: action.appendResults
              ? removeDuplic([...state.clients, ...action.clients])
              : action.clients,
            clientData: action.clients[0],
            loadedAllClients: action.loadedAllClients,
          }
        }
      } else {
        return {
          ...state,
          clients: removeDuplic([...state.clients, ...action.clients]),
          loadedAllClients: action.loadedAllClients,
        }
      }
    case SET_CLIENTS:
      return {
        ...state,
        clients: action.clients,
      }
    case SET_LOADING:
      return {
        ...state,
        loadingClients: action.loadingClients,
      }
    case SELECT_CLIENT:
      return {
        ...state,
        clientData: action.clientData,
      }
    case GET_TRAINERS:
      return {
        ...state,
        trainers: action.trainers,
      }
    case SET_APPROVE_REQUIRED:
      return {
        ...state,
        isNewClientApproveRequired: action.isRequired,
      }
    default:
      return state
  }
}

// Actions
export const getClients = (page = 1, buildingId = 0, trainerId = 0, query = '', pageSize = 25) => {
  const start = (page - 1) * pageSize
  return function (dispatch) {
    return API.getClients(start, pageSize, buildingId, trainerId, query)
      .then((clients) => {
        dispatch({
          type: GET_CLIENTS,
          clients,
          page,
          loadedAllClients: clients.length < pageSize,
        })
        dispatch(setLoading(false))
        return Promise.resolve(clients)
      })
      .catch((err) => {
        dispatch(setLoading(false))
        throw new Error(err)
      })
  }
}

export const getClientsWithCount = (
  page = 1,
  buildingId = 0,
  trainerId = 0,
  query = '',
  pageSize = 25,
  filter = null,
  appendResults = false,
) => {
  const start = (page - 1) * pageSize
  return function (dispatch) {
    dispatch(setLoading(true))
    return API.getClientsWithCount(start, pageSize, buildingId, trainerId, query, filter)
      .then((clientsData) => {
        dispatch({
          type: GET_CLIENTS,
          clients: clientsData?.clients || [],
          page: 1,
          loadedAllClients: clientsData.clients?.length < pageSize,
          appendResults,
        })
        dispatch(setLoading(false))
        return Promise.resolve(clientsData.count)
      })
      .catch((err) => {
        dispatch(setLoading(false))
        throw err
      })
  }
}

export const setLoadingState = (loadingClients) => {
  return function (dispatch) {
    dispatch(setLoading(loadingClients))
  }
}

export const fetchProspectClients = (updateOnlyClientsList = false) => {
  return function (dispatch) {
    API.getProspectClients()
      .then((clients) => {
        dispatch({
          type: GET_CLIENTS,
          clients,
          page: 1,
          loadedAllClients: true,
          updateOnlyClientsList,
        })
      })
      .catch((err) => {
        throw new Error(err)
      })
  }
}

export const fetchInactiveClients = (buildingId) => {
  return (dispatch) => {
    dispatch(setLoading(true))
    API.getInactiveClients(buildingId)
      .then((clients) => {
        dispatch({
          type: GET_CLIENTS,
          clients,
          page: 1,
          loadedAllClients: true,
        })
        dispatch(setLoading(false))
      })
      .catch((err) => {
        dispatch(setLoading(false))
        throw new Error(err)
      })
  }
}

export const setClients = (clients) => {
  return {
    type: SET_CLIENTS,
    clients,
  }
}

export const setSelectedClient = (clientData) => {
  return {
    type: SELECT_CLIENT,
    clientData,
  }
}

const setLoading = (loadingClients) => {
  return {
    type: SET_LOADING,
    loadingClients,
  }
}

export const setClientApproveRequired = (isRequired) => {
  return {
    type: SET_APPROVE_REQUIRED,
    isRequired,
  }
}

export const getTrainers = () => {
  return function (dispatch) {
    API.getAllTrainers()
      .then((trainers) => {
        dispatch({
          type: GET_TRAINERS,
          trainers,
        })
      })
      .catch((err) => {
        throw new Error(err)
      })
  }
}

// Selectors
export const selectClients = (state) => state.clients.clients

export const selectStatusOfLoading = (state) => state.clients.loadingClients

export const selectStatusIsLoadedAll = (state) => state.clients.loadedAllClients

export const selectClientById = createSelector(selectClients, (clients) => (clientId) => {
  return clients.find(({ id }) => id === Number(clientId)) || {}
})

export const selectClientByEmail = createSelector(selectClients, (clients) => (email) => {
  return clients.find(({ user }) => user.email === email) || {}
})

export default clientsReducer
